import { actionCreatorFactory } from 'typescript-fsa';
import { IResolverMeta } from '@cbridge-utils/redux-observable';
import { IClient, IClientUpdate } from './client.interface';

export namespace ClientAction {
  const actionCreator = actionCreatorFactory('Client');

  interface IClientUpdateParams extends IResolverMeta {
    payload: IClientUpdate;
  }

  export const update = actionCreator.async<IClientUpdateParams, void, void>('UPDATE');
  export const remove = actionCreator.async<{ clientId: IClient['clientId'] }, void, void>('REMOVE');
}
